import { FormikProps } from "formik";
import { trackerApi } from "../../core/api/TrackerApi";
import { ApiRouteParameter } from "../../core/api/WebApiTypes";
import { StaleTimeEnum, useMutationCommand, useMutationCreate, useQueryArray, useQueryObjectForm } from "../../core/components/helpers/queryHelper";
import { LocationDto } from "../locations/LocationDtos";
import { OotTrickLinkDto, OotTricksDto } from "./OotTricksDtos";



const fetchOotTricks = async (locationId?: number) => {

    let param: Array<ApiRouteParameter> = [
        { name: "locationId", value: locationId }
    ]
    let data: Array<OotTricksDto> = await trackerApi.callServiceGet("/oot/tricks", param)

    return data;
}

export const useQueryOotTricks = (locationId?: number) => {

    let query = useQueryArray<OotTricksDto>(["oot/tricks"], () => fetchOotTricks(locationId), "Oot Location")

    return query;
}

const fetchOotTrickById = async (id: number) => {
    if (isNaN(id))
        return {} as CreateOotTrickDto;

    let data: CreateOotTrickDto = await trackerApi.callServiceGetById("/oot/tricks", id)

    data.nbLinks = data.links.length;

    return data;
}

export const useQueryOotTrickById = (id: number) => {
    let query = useQueryObjectForm<CreateOotTrickDto>(["/oot/tricks", id], () => fetchOotTrickById(id), "Get Trick By Id")

    return query;
}

const fetchOotUserFavoriteTricks = async () => {
    var data: Array<OotTrickLinkDto> = await trackerApi.callServiceGet("/oot/tricks/favorite")

    return data;
}

export const useQueryUserFavoriteTricks = () => {
    let query = useQueryArray<OotTrickLinkDto>(["oot/tricks/favorite"], fetchOotUserFavoriteTricks, "Oot User Favorite Trick", StaleTimeEnum.HEAVY)

    return query;
}


const addOrRemoveTrickToFavorite = async (trickLinkId: number) => {
    await trackerApi.callServicePost("/oot/tricks/favorite", { trickLinkId: trickLinkId })
}


export const useMutationAddOrRemoveTrickToFavortie = () => {

    let mutation = useMutationCommand(addOrRemoveTrickToFavorite, "Trick to Favorite", ["oot/tricks/favorite"]);

    return mutation;
}

export interface CreateOotTrickDto {
    id: number,
    name: string,
    description: string,
    location: LocationDto | null
    links: Array<OotTrickLinkDto>,
    nbLinks: number
}

const createTrick = async (values: CreateOotTrickDto) => {
    await trackerApi.callServicePost("/oot/tricks", values)
}

export const useMutateCreateOotTrick = (formikRef: React.RefObject<FormikProps<CreateOotTrickDto>>) => {
    let mutate = useMutationCreate(formikRef, createTrick, [], "Create Oot Tricks");

    return mutate;
}

const updateTrick = async (values: CreateOotTrickDto) => {
    await trackerApi.callServicePut("/oot/tricks", values.id ?? 0, values)
}

export const useMutateUpdateOotTrick = (formikRef: React.RefObject<FormikProps<CreateOotTrickDto>>) => {
    let mutate = useMutationCreate(formikRef, updateTrick, [], "Update Oot Tricks");

    return mutate;
}